import { getAuthToken } from "@helpers/auth-provider";
import axios from "axios";

const authAxios = axios.create();

authAxios.interceptors.request.use(async (config) => {
	const token = await getAuthToken();
	if (token) {
		// TODO(backend): switch to `Bearer ${token}` (RFC 7235) once API gateway accepts the prefix.
		config.headers.Authorization = token;
	}
	return config;
});

export default authAxios;
